/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewFindingRecordAPIResponse } from './CRSFSecReviewFindingRecordAPIResponse';
import {
    CRSFSecReviewFindingRecordAPIResponseFromJSON,
    CRSFSecReviewFindingRecordAPIResponseFromJSONTyped,
    CRSFSecReviewFindingRecordAPIResponseToJSON,
} from './CRSFSecReviewFindingRecordAPIResponse';

/**
 * 
 * @export
 * @interface CRSFSecReviewFindingsPagedResponse
 */
export interface CRSFSecReviewFindingsPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewFindingsPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewFindingsPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewFindingRecordAPIResponse>}
     * @memberof CRSFSecReviewFindingsPagedResponse
     */
    results?: Array<CRSFSecReviewFindingRecordAPIResponse>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewFindingsPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewFindingsPagedResponse interface.
 */
export function instanceOfCRSFSecReviewFindingsPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewFindingsPagedResponseFromJSON(json: any): CRSFSecReviewFindingsPagedResponse {
    return CRSFSecReviewFindingsPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewFindingsPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewFindingsPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewFindingRecordAPIResponseFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewFindingsPagedResponseToJSON(value?: CRSFSecReviewFindingsPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewFindingRecordAPIResponseToJSON)),
        'total': value.total,
    };
}

